import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowDropIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.414 9c-.89 0-1.337 1.077-.707 1.707l3.586 3.586a1 1 0 001.414 0l3.586-3.586c.63-.63.184-1.707-.707-1.707H8.414z"/>
    </SvgIcon>
);
